import React

from "react";

import {

    OMNISCAN_BLUE

}

from "../../../constants/colors";

import DocumentRow

from "./DocumentRow";



//========================================================
// Document Page
//========================================================

export default function DocumentPage({

    page,

    pageNumber,

    canDelete,

    basketItems = [],

    onDeletePage,

    onAddRow,

    onDeleteRow,

    onMoveRow,

    onChangeRowLayout,

    onSetCellContent,

    onClearCellContent,

    onUpdateCellContent,

    onSetPageOrientation

})

{

    //========================================================
    // Orientation
    //========================================================

    const landscape =

        page?.orientation === "LANDSCAPE";



    //========================================================
    // Page Style
    //
    // Approximate A4 proportions at 96 DPI.
    //========================================================

    const pageStyle =

    {

        ...styles.page,

        width:

            landscape

                ?

                1123

                :

                794,

        minHeight:

            landscape

                ?

                794

                :

                1123

    };



    //========================================================
    // Render
    //========================================================

    return (

        <div style={styles.pageWrapper}>

            {/*============================================
                Page Toolbar
            ============================================*/}

            <div

                style={

                    {

                        ...styles.pageToolbar,

                        width:

                            landscape

                                ?

                                1123

                                :

                                794

                    }

                }

            >

                <div style={styles.pageNumber}>

                    PAGE {pageNumber}

                </div>



                <div style={styles.pageActions}>

                    <button

                        type="button"

                        style={

                            {

                                ...styles.toolbarButton,

                                ...(

                                    !landscape

                                        ?

                                        styles.toolbarButtonActive

                                        :

                                        {}

                                )

                            }

                        }

                        onClick={

                            () =>

                            {

                                onSetPageOrientation(

                                    page.id,

                                    "PORTRAIT"

                                );

                            }

                        }

                    >

                        Portrait

                    </button>



                    <button

                        type="button"

                        style={

                            {

                                ...styles.toolbarButton,

                                ...(

                                    landscape

                                        ?

                                        styles.toolbarButtonActive

                                        :

                                        {}

                                )

                            }

                        }

                        onClick={

                            () =>

                            {

                                onSetPageOrientation(

                                    page.id,

                                    "LANDSCAPE"

                                );

                            }

                        }

                    >

                        Landscape

                    </button>



                    {

                        canDelete &&

                        (

                            <button

                                type="button"

                                style={

                                    styles.deletePageButton

                                }

                                onClick={

                                    () =>

                                    {

                                        onDeletePage(

                                            page.id

                                        );

                                    }

                                }

                            >

                                Delete Page

                            </button>

                        )

                    }

                </div>

            </div>



            {/*============================================
                Paper
            ============================================*/}

            <div style={pageStyle}>

                <div style={styles.pageContent}>

                    {/*========================================
                        Empty Page
                    ========================================*/}

                    {

                        page.rows.length === 0 &&

                        (

                            <div style={styles.emptyPage}>

                                <div style={styles.emptyTitle}>

                                    Empty Page

                                </div>

                                <div style={styles.emptyText}>

                                    Add a row to begin composing

                                    this page.

                                </div>

                            </div>

                        )

                    }



                    {/*========================================
                        Rows
                    ========================================*/}

                    {

                        page.rows.map(

                            (row, index) =>

                                <DocumentRow

                                    key={

                                        row.id

                                    }

                                    pageId={

                                        page.id

                                    }

                                    row={

                                        row

                                    }

                                    rowNumber={

                                        index + 1

                                    }

                                    canMoveUp={

                                        index > 0

                                    }

                                    canMoveDown={

                                        index <

                                        page.rows.length - 1

                                    }

                                    basketItems={

                                        basketItems

                                    }

                                    onDeleteRow={

                                        onDeleteRow

                                    }

                                    onMoveRow={

                                        onMoveRow

                                    }

                                    onChangeRowLayout={

                                        onChangeRowLayout

                                    }

                                    onSetCellContent={

                                        onSetCellContent

                                    }

                                    onClearCellContent={

                                        onClearCellContent

                                    }

                                    onUpdateCellContent={

                                        onUpdateCellContent

                                    }

                                />

                        )

                    }



                    {/*========================================
                        Add Row
                    ========================================*/}

                    <button

                        type="button"

                        style={

                            styles.addRowButton

                        }

                        onClick={

                            () =>

                            {

                                onAddRow(

                                    page.id,

                                    [100]

                                );

                            }

                        }

                    >

                        <span style={styles.addIcon}>

                            +

                        </span>

                        Add Row

                    </button>

                </div>

            </div>

        </div>

    );

}



//========================================================
// Styles
//========================================================

const styles =

{

    pageWrapper:

    {

        display:

            "flex",

        flexDirection:

            "column",

        alignItems:

            "center"

    },



    //========================================================
    // Page Toolbar
    //========================================================

    pageToolbar:

    {

        height:

            38,

        marginBottom:

            8,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "space-between",

        transition:

            "width 220ms ease"

    },

    pageNumber:

    {

        fontSize:

            9,

        fontWeight:

            700,

        letterSpacing:

            1.2,

        color:

            "rgba(38,55,70,0.42)"

    },

    pageActions:

    {

        display:

            "flex",

        alignItems:

            "center",

        gap:

            5

    },

    toolbarButton:

    {

        height:

            28,

        padding:

            "0 10px",

        border:

            "1px solid rgba(38,55,70,0.12)",

        borderRadius:

            4,

        background:

            "rgba(255,255,255,0.60)",

        color:

            "rgba(38,55,70,0.60)",

        fontSize:

            9,

        fontWeight:

            600,

        cursor:

            "pointer"

    },

    toolbarButtonActive:

    {

        border:

            "1px solid rgba(32,175,232,0.40)",

        background:

            "rgba(32,175,232,0.08)",

        color:

            OMNISCAN_BLUE

    },

    deletePageButton:

    {

        height:

            28,

        marginLeft:

            5,

        padding:

            "0 10px",

        border:

            "1px solid rgba(166,60,60,0.18)",

        borderRadius:

            4,

        background:

            "rgba(166,60,60,0.04)",

        color:

            "#9a4a4a",

        fontSize:

            9,

        fontWeight:

            600,

        cursor:

            "pointer"

    },



    //========================================================
    // Paper
    //========================================================

    page:

    {

        position:

            "relative",

        background:

            "#ffffff",

        boxShadow:

            "0 12px 34px rgba(20,35,50,0.13)",

        boxSizing:

            "border-box",

        transition:

            "width 220ms ease, min-height 220ms ease"

    },

    pageContent:

    {

        minHeight:

            "100%",

        padding:

            "56px 52px",

        boxSizing:

            "border-box"

    },



    //========================================================
    // Empty Page
    //========================================================

    emptyPage:

    {

        height:

            100,

        marginBottom:

            18,

        display:

            "flex",

        flexDirection:

            "column",

        alignItems:

            "center",

        justifyContent:

            "center",

        border:

            "1px dashed rgba(38,55,70,0.14)",

        borderRadius:

            5,

        background:

            "rgba(244,247,249,0.55)"

    },

    emptyTitle:

    {

        marginBottom:

            4,

        color:

            "rgba(38,55,70,0.55)",

        fontSize:

            11,

        fontWeight:

            600

    },

    emptyText:

    {

        color:

            "rgba(38,55,70,0.38)",

        fontSize:

            10

    },



    //========================================================
    // Add Row
    //========================================================

    addRowButton:

    {

        width:

            "100%",

        height:

            38,

        marginTop:

            10,

        display:

            "flex",

        alignItems:

            "center",

        justifyContent:

            "center",

        gap:

            7,

        border:

            "1px dashed rgba(32,175,232,0.40)",

        borderRadius:

            5,

        background:

            "rgba(32,175,232,0.025)",

        color:

            OMNISCAN_BLUE,

        fontSize:

            10,

        fontWeight:

            600,

        cursor:

            "pointer"

    },

    addIcon:

    {

        fontSize:

            17,

        lineHeight:

            1

    }

};